module.exports = __webpack_public_path__ + "static/img/new01.2f2f09fe.png";